module.exports = __webpack_public_path__ + "media/images/news/icon_twitter-f000a22ed59f0d35b2a6b73813b62298.svg";